export default __webpack_public_path__ + "static/media/main_section22.0c0141c9.jpg";